import { TableRow } from "@material-ui/core";

export const NestedRow = (props) => {
  return <TableRow className="NestedRow">{props.children}</TableRow>;
};
